import h from 'react-hyperscript';
import { Button } from 'reactstrap';

import pkgJson from '../../../package.json';

const { config: { shortName: companyNameShort } } = pkgJson;

const redirectToAction = () => {
  // TODO: Wire up
  console.error('Not implemented!'); // eslint-disable-line no-console
};

export default () =>
  h('.card.border-primary', [
    h('.card-header', [h('h4', 'Your trial has ended')]),
    h('.card-block', [
      h('.card-body', [
        "All good things come to an end, but they don't have to. Start your subscription today and you will instantly be back to analytic bliss.",
      ]),
      h('br'),
      h('.text-center', [
        h(Button, { color: 'primary', onClick: redirectToAction }, `Continue with ${companyNameShort}`),
      ]),
      h('br'),
      h('.text-center', [h('b', 'Only $XX per month for unlimited insights into your data.')]),
    ]),
  ]);



// WEBPACK FOOTER //
// ./src/components/Card/CardTrialEnded.js